import { baseTemplateParams } from '../shared/baseParams.js'

export const defaultTemplateParams = {
  ...baseTemplateParams,
  headerBgColor: '#ffffff',
  logoUrl: '',
  heroImgUrl: '',
  heroImageLinkUrl: '',
  preheaderText: 'This text will appear next to your subject line in the inbox.',
  subject: 'This is the email subject',
  ctaBackgroundColor: '#2563eb',
  ctaTextColor: '#ffffff',
  selectedTemplate: 'centeredHero',
  shellTemplateKey: 'centeredHero',
  logoWidth: '72px',
  logoHeight: '72px'
}

export default defaultTemplateParams
